/*
 * The bottom tabs, same shape as Alex's phone layout. Categories are not tabs
 * — they live in the chip row above, so the way into anything never moves.
 *
 * Five is the ceiling. Calendar earns its place because dated things were
 * scattered across the app with nowhere that showed them together; Reminders
 * stays separate because a reminder is a thing to act on, not a thing to
 * look at on a grid.
 */
export const ICONS = {
  today:     <><rect x="3.5" y="4.5" width="17" height="16" rx="3" /><path d="M3.5 9.5h17M8 3v3M16 3v3" /></>,
  calendar:  <><rect x="3.5" y="4.5" width="17" height="16" rx="3" /><path d="M3.5 9.5h17M8 3v3M16 3v3" /><rect x="7" y="12.5" width="3" height="3" rx="1" fill="currentColor" stroke="none" /></>,
  reminders: <><circle cx="12" cy="12" r="8" /><path d="M12 8v4l3 2" /></>,
  log:       <><path d="M5 4h14v16H5z" /><path d="M8.5 8.5h7M8.5 12h7M8.5 15.5h4" /></>,
  search:    <><circle cx="11" cy="11" r="6.5" /><path d="m16 16 4 4" /></>,
}

export const TABS = [
  { key: 'today',     label: 'Today',     icon: 'today' },
  { key: 'calendar',  label: 'Calendar',  icon: 'calendar' },
  { key: 'reminders', label: 'Reminders', icon: 'reminders' },
  { key: 'log',       label: 'Log',       icon: 'log' },
  { key: 'search',    label: 'Search',    icon: 'search' },
]

export default function TabBar({ current, onChange }) {
  return (
    <nav className="tabbar" role="tablist" aria-label="Sections">
      {TABS.map((t) => (
        <button
          key={t.key}
          type="button"
          role="tab"
          className="tab"
          aria-current={t.key === current ? 'page' : undefined}
          aria-selected={t.key === current}
          onClick={() => onChange(t.key)}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            {ICONS[t.icon]}
          </svg>
          <span>{t.label}</span>
        </button>
      ))}
    </nav>
  )
}
